module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2018_professional_winner-44ce689938eac2b8dc7557f3b3c6ad16.jpg";